class CartDrawer {
  constructor() {
          this.bindInit();
  }
  bindInit() {
    this.DrawerPopup();
    this.storeCoupon();
    this.storeNote();
  }

  DrawerPopup() {
    const drawerPopupContainer = document.querySelectorAll(".js-drawer-popup");
    const drawerPopupTrigger = document.querySelectorAll(".js-drawer-form-popup");
    const drawerPopupClose = document.querySelectorAll('.js-close-popup');

    drawerPopupTrigger.forEach(getDrawerPopupValue => {
      getDrawerPopupValue.addEventListener("click", () => {
        drawerPopupContainer.forEach(getDrawerPopupContainer => {
              if (getDrawerPopupContainer.getAttribute('data-value') === getDrawerPopupValue.getAttribute('data-value')) {
                getDrawerPopupContainer.classList.add('is-active');
              }
          });
      });
    });

    drawerPopupClose.forEach(getDrawerPopupClose => {
      getDrawerPopupClose.addEventListener("click", () => {
          drawerPopupContainer.forEach(getDrawerPopupContainer => {
            getDrawerPopupContainer.classList.remove('is-active');
          });
        });
    });
  }

  storeCoupon() {
    const drawerPopupContainer = document.querySelectorAll(".js-drawer-popup");
    const addCoupon = document.querySelector('.js-add-coupon');
    const addCouponBTN = document.querySelector('.js-add-coupon-submit');

    addCouponBTN.addEventListener("click", () => {
      localStorage.setItem("couponvalue", addCoupon.value);

      drawerPopupContainer.forEach(getDrawerPopupContainer => {
        getDrawerPopupContainer.classList.remove('is-active');
      });
    });

    if (localStorage.getItem("couponvalue") != null) {
      addCoupon.value = localStorage.getItem("couponvalue");
    }
  }

  storeNote() {
    const drawerPopupContainer = document.querySelectorAll(".js-drawer-popup");
    const addNote = document.querySelector('.js-add-note');
    const addNoteBTN = document.querySelector('.js-add-note-submit');

    addNoteBTN.addEventListener("click", () => {
      localStorage.setItem("Notevalue", addNote.value);

      drawerPopupContainer.forEach(getDrawerPopupContainer => {
        getDrawerPopupContainer.classList.remove('is-active');
      });
    });

    if (localStorage.getItem("Notevalue") != null) {
      addNote.textContent = localStorage.getItem("Notevalue");
    }
  }
}

new CartDrawer();
